import store from '@/plugins/vuex'
import axios from '@/plugins/axios'

const routes = [
  {
    path: '/artist/my-tracks',
    name: 'My Tracks',
    component: () =>
      import(/* webpackChunkName: 'my-tracks-artist' */ './views/Index.vue')
  },
  {
    path: '/artist/my-tracks/track-details',
    name: 'Track Dashboard',
    title: 'Tracks Details',
    props: route => ({ query: route.query.id }),
    beforeEnter(to, from, next) {
      if (!isNaN(to.query.track)) {
        let artist = {
          id: null,
          name: null,
          file_name: null
        }
        axios.artist
          .get('mytracks', {
            params: {
              track: to.query.track
            }
          })
          .then(r => {
            store.commit('artistDashboard/setSelectedTrack', r.data.data[0])
            artist.id = r.data.data[0].artist_id
            artist.name = r.data.data[0].artist_name
            artist.file_name = r.data.data[0].file_name
            store.commit('artistDashboard/setSelectedArtist', artist)
            if (store.state.artistDashboard.artist_track == null) {
              if (store.state.auth.user.user_level == 'label_admin') {
                next({
                  name: 'My Artists'
                })
              } else {
                next({
                  name: 'My Tracks'
                })
              }
            } else {
              next()
            }
          })
          .catch(() => {
            if (store.state.artistDashboard.artist_track == null) {
              if (store.state.auth.user.user_level == 'label_admin') {
                next({
                  name: 'My Artists'
                })
              } else {
                next({
                  name: 'My Tracks'
                })
              }
            } else {
              next()
            }
          })
      } else {
        if (store.state.artistDashboard.artist_track == null) {
          if (store.state.auth.user.user_level == 'label_admin') {
            next({
              name: 'My Artists'
            })
          } else {
            next({
              name: 'My Tracks'
            })
          }
        } else {
          next()
        }
      }
    },
    component: () =>
      import(
        /* webpackChunkName: 'track-details-artist' */ './views/TrackDetails.vue'
      )
  },
  {
    path: '/artist/my-tracks/overview',
    name: 'My Tracks Overview',
    component: () =>
        import(/* webpackChunkName: 'my-tracks-overview-artist' */ './views/Overview.vue'),
    beforeEnter(to, from, next) {
      if (
          store.state.auth.user.user_level === 'label_admin' &&
          store.state.artistDashboard.artist_label === null

      ) next({ name: 'My Artists' })
      else next()
    }
  },
  {
    path: '/artist/submit-music',
    name: 'Submit Music',
    component: () =>
        import(/* webpackChunkName: 'submit-music' */ './views/SubmitMusic.vue')
  },
]

export default routes
